export default function GenericAvatar({
  size = 100,
  fill = "#C4C4C4",
}: {
  size?: number;
  fill?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" rx="50" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.0006 40C65.0006 48.2843 58.2849 55 50.0006 55C41.7163 55 35.0006 48.2843 35.0006 40C35.0006 31.7157 41.7163 25 50.0006 25C58.2849 25 65.0006 31.7157 65.0006 40ZM60.0006 40C60.0006 45.5229 55.5235 50 50.0006 50C44.4778 50 40.0006 45.5229 40.0006 40C40.0006 34.4772 44.4778 30 50.0006 30C55.5235 30 60.0006 34.4772 60.0006 40Z"
        fill="white"
      />
      <path
        d="M50.0006 62.5C33.8147 62.5 20.0238 72.071 14.7705 85.4801C16.0502 86.7509 17.3984 87.9529 18.8088 89.0801C22.7207 76.7692 34.9924 67.5 50.0006 67.5C65.0088 67.5 77.2806 76.7693 81.1924 89.0802C82.6029 87.9529 83.951 86.7509 85.2307 85.4802C79.9775 72.071 66.1866 62.5 50.0006 62.5Z"
        fill="white"
      />
    </svg>
  );
}
